<div class="flex" style="margin-top: 8px;">
  <div class="card w-full">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
      <div class="p-datatable-header">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex flex-column md:flex-row">
            <button
              [label]="'common.new' | transloco"
              pButton
              pRipple
              class="md:mr-2 p-button-primary mb-2 md:mb-0"
              routerLink="default-decoders/new"
              icon="pi pi-plus"
            ></button>
            <!--<button
              [label]="'common.delete' | transloco"
              [disabled]="selected.length == 0"
              (click)="confirmAndDeleteSelected()"
              pButton
              pRipple
              class="p-button-danger mb-2 sm:mb-0"
              icon="pi pi-trash"
            ></button>-->
          </div>
          <div *ngIf="!filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary"
              icon="pi pi-sliders-h"
            ></button>
          </div>
          <div *ngIf="filtersFilled" class="flex flex-column md:flex-row justify-content-end">
            <button
              [label]="'common.filters' | transloco"
              (click)="filtersVisible = !filtersVisible"
              pButton
              class="p-button-secondary filtersFilled"
              icon="pi pi-filter"
            ></button>
          </div>
        </div>
      </div>
      <p-table
        [(first)]="first"
        [(rows)]="rows"
        [(selection)]="selected"
        [value]="defaultDecoders"
        [totalRecords]="totalDefaultDecoders"
        [responsive]="true"
        [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
        [paginator]="true"
        [rowsPerPageOptions]="[10,25,50]"
        [lazy]="true"
        (onLazyLoad)="onPageChange($event)"
        styleClass="p-datatable-striped"
        sortField="name"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="selection-column-width"></th>
            <th pSortableColumn="name">
              {{'attribute.name' | transloco}}<p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="type">
              {{'attribute.type' | transloco}}<p-sortIcon field="type"></p-sortIcon></th>
            <th pSortableColumn="creationDate">
              {{'attribute.creationDate' | transloco}}<p-sortIcon field="creationDate"></p-sortIcon></th>
            <th pSortableColumn="updatedDate">
              {{'attribute.updatedDate' | transloco}}<p-sortIcon field="updatedDate"></p-sortIcon></th>
            <th class="w-10rem">
              {{'common.actions' | transloco}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-decoder>
          <tr *ngIf="!loadingDefaultDecoders" class="fadein">
            <td>
              <span class="p-column-title bold">{{'common.select' | transloco}}</span>
              <p-tableCheckbox [value]="decoder"></p-tableCheckbox>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
              <p class="text-right md:text-left">{{decoder.name}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.type' | transloco}}</span>
              <p class="text-right md:text-left">{{decoder.type}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.creationDate' | transloco}}</span>
              <p class="text-right md:text-left">{{decoder.creationDate | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'attribute.updatedDate' | transloco}}</span>
              <p class="text-right md:text-left">{{decoder.updatedDate | customDate}}</p>
            </td>
            <td>
              <span class="p-column-title bold">{{'common.actions' | transloco}}</span>
              <div class="flex justify-content-end">
                <button
                  [routerLink]="['default-decoders', decoder.name, 'edit']"
                  pButton
                  pRipple
                  class="p-button-rounded btn-primary-light mr-2"
                  icon="pi pi-pencil"
                ></button>
                <!--<button
                  (click)="confirmAndDelete(decoder)"
                  pButton
                  pRipple
                  class="p-button-rounded btn-danger-light"
                  icon="pi pi-trash"
                ></button>-->
              </div>
            </td>
          </tr>
          <tr *ngIf="loadingDefaultDecoders" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
            <td class="row-height"><p-skeleton height="1em"></p-skeleton></td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex align-items-center justify-content-between" *ngIf="totalDefaultDecoders == 0">{{'pagination.empty' | transloco}}</div>
          <div class="flex align-items-center justify-content-between" *ngIf="totalDefaultDecoders > 0">
            {{'pagination.showing' | transloco}} {{first+1}}
            {{'pagination.to' | transloco}} {{(first+rows) >= totalDefaultDecoders ? totalDefaultDecoders : (first+rows)}}
            {{'pagination.of' | transloco}} {{totalDefaultDecoders}}
            {{(totalDefaultDecoders > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
          </div>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
  <h2 style="margin-left: 10px;">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="name">{{'attribute.name' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <input
          [(ngModel)]="currentFilters.name"
          [focus]="filtersVisible"
          (keyup.enter)="filtersVisible = false; applyFilters()"
          pInputText
          appAutoFocus
          class="w-full"
          id="name"
          type="text"
        >
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="type">{{'attribute.type' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-dropdown
          [(ngModel)]="currentFilters.type"
          *ngIf="types"
          [placeholder]="'select.generic' | transloco"
          [filter]="false"
          [options]="types"
          styleClass="w-full"
          id="type"
          appendTo="body"
        >
        </p-dropdown>
      </div>
    </div>
    <div class="col-12">
      <p-button
        [label]="'common.filter' | transloco"
        [disabled]="!(
          currentFilters.name ||
          currentFilters.type
        )"
        (onClick)="filtersVisible = false; applyFilters();"
        styleClass="p-button-primary mx-2 mt-2"
        type="button"
      ></p-button>
      <p-button
        [label]="'common.clear' | transloco"
        (click)="resetFilters(); this.filtersVisible = false;"
        styleClass="p-button-danger"
        type="button"
      ></p-button>
    </div>
  </div>
</p-sidebar>
